import { CmsService } from '@omnia/ui/src/lib/services/cms.service'
import type { PagesEnum } from '@/shared/models/pages'
import { navigationService } from '@/web/common/services/navigation.service'
import type { InitialData } from '../../../shared/models/initialData'

export class KinepolisCmsService extends CmsService<InitialData, PagesEnum> { }

// @ts-expect-error -- unfinished type implementation of `SubPageKey`
export const cmsService = new KinepolisCmsService(navigationService)
